module.exports = __webpack_public_path__ + "img/DESIGN_09.2b134c28.jpg";